import React, { useMemo, useState } from 'react';
import { FlightTabs, FlightTabPanel, FlightButton } from '@flybits/design-system';
import './Analytics.scss';
import AnalyticsDashboard from './Overview/AnalyticsDashboard';
import CustomAnalyticsDashboard from './CustomAnalytics/Dashboard/CustomAnalyticsDashboard';
import { useHistory, useParams } from 'react-router-dom';
import { TAnalyticsRouteParams } from 'pages/AnalyticsV2/types';

// CLASSES
const CLASS_MAIN = 'analytics-container';
const CLASSES = {
  BODY: `${CLASS_MAIN}__body`,
  HEADER: `${CLASS_MAIN}__header`,
  CONTAINER: `${CLASS_MAIN}__container`,
  TABS: `${CLASS_MAIN}__tabs`,
  ADDBUTTON: `${CLASS_MAIN}__addbutton`,
};

function Analytics() {
  const [selectedTab, setSelectedTab] = useState('overview');
  const history = useHistory();
  const { pid } = useParams<TAnalyticsRouteParams>();

  useMemo(() => {
    const showCustomAnalyticsTab = new URLSearchParams(window.location.search).has('showCustomAnalyticsTab');
    showCustomAnalyticsTab && setSelectedTab('custom');
  }, []);

  return (
    <main className={CLASSES.BODY}>
      <div className={CLASSES.HEADER}>
        <div className={CLASSES.TABS}>
          <FlightTabs
            labels={[
              { key: 'overview', name: 'Overview' },
              { key: 'custom', name: 'Custom analytics' },
            ]}
            selectedTab={selectedTab}
            onSelect={(e: { key: string }) => {
              setSelectedTab(e.key);

              if (e.key === 'overview') {
                // Remove all url params
                window.history.replaceState(null, '', window.location.pathname);
              }
            }}
          />
        </div>

        {selectedTab === 'custom' && ( // Only show if it is experience dashboard
          <div className={CLASSES.ADDBUTTON}>
            <FlightButton
              type="submit"
              iconLeft="add"
              label="Add chart"
              onClick={() => history.push(`/project/${pid}/analytics/v2/moduleconfig`)}
            ></FlightButton>
          </div>
        )}
      </div>

      <div className={CLASSES.CONTAINER}>
        {selectedTab === 'overview' && ( // The first item here is the Overview tab
          <FlightTabPanel>
            <AnalyticsDashboard />
          </FlightTabPanel>
        )}

        {selectedTab === 'custom' && (
          <FlightTabPanel>
            <CustomAnalyticsDashboard />
          </FlightTabPanel>
        )}
      </div>
    </main>
  );
}

export default Analytics;
